import CreatedAt from "./CreatedAt";
import UpdatedAt from "./UpdatedAt";

class Trail {
  constructor(
    private readonly _createdAt: CreatedAt = new CreatedAt(),
    private readonly _updatedAt: UpdatedAt = new UpdatedAt(),
  ) {}

  get createdAt() {
    return this._createdAt;
  }

  get updatedAt() {
    return this._updatedAt;
  }
}

export default Trail;
